import { render } from "./Pagination.vue?vue&type=template&id=d11c2c10"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Pagination.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d11c2c10"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d11c2c10', __exports__)) {
    api.reload('d11c2c10', __exports__)
  }
  
  module.hot.accept("./Pagination.vue?vue&type=template&id=d11c2c10", () => {
    api.rerender('d11c2c10', render)
  })

}


export default __exports__